"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _constants = require("./constants");

var _default = new _immutable.Record({
  calculated: null,
  description: null,
  displayMode: null,
  displayOrder: null,
  externalOptions: null,
  favorited: null,
  favoritedOrder: null,
  fieldType: null,
  formField: null,
  groupName: null,
  hidden: null,
  hubspotDefined: null,
  label: null,
  mutableDefinitionNotDeletable: null,
  name: null,
  options: null,
  readOnlyDefinition: null,
  readOnlyValue: null,
  referencedObjectType: null,
  type: null
}, _constants.PROPERTY);

exports.default = _default;
module.exports = exports.default;